import { defineComponent as _defineComponent } from 'vue'
import { createElementVNode as _createElementVNode, openBlock as _openBlock, createElementBlock as _createElementBlock, createCommentVNode as _createCommentVNode } from "vue"

const _hoisted_1 = {
  key: 0,
  xmlns: "http://www.w3.org/2000/svg",
  width: "9",
  height: "6",
  viewBox: "0 0 9 6",
  fill: "none",
  class: "w-4 h-4 text-black hover:text-blue-500"
}
const _hoisted_2 = /*#__PURE__*/_createElementVNode("path", {
  d: "M3.98229 0.34125L0.68504 4.10944C0.295915 4.55425 0.612164 5.25 1.20273 5.25H7.79723C7.9294 5.25011 8.05879 5.21213 8.16993 5.14059C8.28106 5.06905 8.36922 4.967 8.42385 4.84665C8.47847 4.7263 8.49725 4.59275 8.47793 4.462C8.45861 4.33125 8.40201 4.20885 8.31491 4.10944L5.01766 0.341938C4.95314 0.268094 4.87355 0.208909 4.78426 0.168358C4.69498 0.127807 4.59804 0.106827 4.49998 0.106827C4.40191 0.106827 4.30498 0.127807 4.21569 0.168358C4.1264 0.208909 4.04682 0.268094 3.98229 0.341938V0.34125Z",
  fill: "currentColor"
}, null, -1)
const _hoisted_3 = [
  _hoisted_2
]
const _hoisted_4 = {
  key: 1,
  xmlns: "http://www.w3.org/2000/svg",
  width: "9",
  height: "6",
  viewBox: "0 0 9 6",
  fill: "none",
  class: "w-4 h-4 text-black transform rotate-180 hover:text-blue-500"
}
const _hoisted_5 = /*#__PURE__*/_createElementVNode("path", {
  d: "M3.98229 0.34125L0.68504 4.10944C0.295915 4.55425 0.612164 5.25 1.20273 5.25H7.79723C7.9294 5.25011 8.05879 5.21213 8.16993 5.14059C8.28106 5.06905 8.36922 4.967 8.42385 4.84665C8.47847 4.7263 8.49725 4.59275 8.47793 4.462C8.45861 4.33125 8.40201 4.20885 8.31491 4.10944L5.01766 0.341938C4.95314 0.268094 4.87355 0.208909 4.78426 0.168358C4.69498 0.127807 4.59804 0.106827 4.49998 0.106827C4.40191 0.106827 4.30498 0.127807 4.21569 0.168358C4.1264 0.208909 4.04682 0.268094 3.98229 0.341938V0.34125Z",
  fill: "currentColor"
}, null, -1)
const _hoisted_6 = [
  _hoisted_5
]

import { ref } from "vue";
import { useRoute } from "vue-router";


export default /*#__PURE__*/_defineComponent({
  __name: 'SortableTableHeader',
  props: {
  column: {
    type: String,
    required: true,
  },
},
  emits: ["sort"],
  setup(__props, { emit: emits }) {

const props = __props;

const route = useRoute();



const direction = ref("asc");



function sortBy() {
  if (direction.value === "asc") {
    direction.value = "desc";
  } else {
    direction.value = "asc";
  }

  emits("sort", props.column, direction.value);
}

if (route.query.sort === props.column) {
  // @ts-ignore
  direction.value = route.query.dir;
}

return (_ctx: any,_cache: any) => {
  return (_openBlock(), _createElementBlock("button", { onClick: sortBy }, [
    (direction.value === 'desc')
      ? (_openBlock(), _createElementBlock("svg", _hoisted_1, _hoisted_3))
      : _createCommentVNode("", true),
    (direction.value === 'asc')
      ? (_openBlock(), _createElementBlock("svg", _hoisted_4, _hoisted_6))
      : _createCommentVNode("", true)
  ]))
}
}

})